/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

// Import the Plugin Class so we could extend off the base functionality:
import { Plugin } from 'ckeditor5';
import { BulbDeleteBlockUI } from './bulbdeleteblockui';

/**
 * Custom image plugin for ckeditor that allows us to follow our current workflow of uploading and image to a page.
 * I.E from the assetlibrary, etc...
 */
export default class BulbDeleteBlock extends Plugin {

  /**
   * @inheritDoc
   */
  public static get requires() {
    return [BulbDeleteBlockUI] as const;
  }

  /**
   * @inheritDoc
   */
  public static get pluginName() {
    return 'BulbDeleteBlock' as const;
  }
}
